import { t, getWeekDay, getDayAndMonth, getFullMinute } from "../../services/formatters";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/splide/dist/css/splide.min.css";
import { useFilialiPage } from "./useFilialiPage";
import widgetOptions from "../../config/widgets.json";
import { Button } from "../../components/Button";
import { Breadcrumb } from "../../components/Breadcrumb";
import { ErrorModal } from "../../components/ErrorModal";
import { useEffect } from "react";
import { EditAppointmentModal } from "../../components/EditAppointmentModal";
import { useLocation } from "react-router-dom";
import agenteImg from "../../assets/imgs/agente-clink-direct.svg";
import "./FilialiPage.css";

export const FilialiPage = () => {
    const {
        next,
        read,
        update,
        subSlider,
        daySlider,
        onFilialiSlideChange,
        onGiorniSlideChange,
        isFilialiSlideBusy,
        isCfPageReady,
        showMap,
        currentMapToShow,
        fetchErrorMessage,
        fetchError,
        setFetchError,
        showModal,
        closeModal,
    } = useFilialiPage();
    const { state } = useLocation();

    useEffect(() => {
        window.dataLayer.push({
            event: "customPageview",
            virtualPageURL: "/fa3/fissa-appuntamento/data-appuntamento",
            funnelVersion: "nuovo",
            capFiliale: read("cap"),
            presa_info: read("solo_info"),
        });
    }, []);

    return (
        <div id="filiali-page">
            <Breadcrumb text={read("luogo")} navigateTo="/" />

            {state && state.clinkDirectTitle ? (
                <div className={`section page-title-component text-center`}>
                    <h1>
                        <span>Ciao {read("nome")}</span>,                        
                    </h1>
                    <br />
                    <p>l’agente scelto non può venire da te, <b>fissa un appuntamento</b> nel punto vendita più vicino</p>
                    <br />
                    <img src={agenteImg} alt="" />
                </div>
            ) : (
                <div className={`section page-title-component center-on-tablet`}>
                    <h1>
                        <span>Ciao!</span> <br /> <span>Il tuo appuntamento:</span>
                    </h1>
                </div>
            )}

            {/* SLIDERS */}
            {/* filiali */}
            <div id="subs-splide" className={`section full-screen on-mobile`}>
                <div className="fade"></div>
                <Splide
                    ref={subSlider}
                    options={{ ...widgetOptions.splideFiliali, start: read("filialeSceltaIdx") }}
                    onMoved={(splide, newIdx) => {
                        onFilialiSlideChange(newIdx);
                        update("filialeSceltaIdx", newIdx);
                    }}
                    onClick={(splide, slide) => {                        
                        update("log_filiale_clicks", read("log_filiale_clicks") + 1);                        
                    }}
                    onReady={(splide, slide) => {}}>
                    {read("filiali").map((i, idx) => (
                        <SplideSlide key={`${i.filiale}-${idx}`}>
                            <div className={`white-box subsidiary-card-component clickable  ${currentMapToShow == `map-${idx}` ? "show-map" : ""}`}>
                                <h2>{i.nomeFiliale}</h2>
                                <p aria-label={i.indirizzo} className={`subsidiary-card-subtitle ${!i.indirizzo ? "invisible" : ""}`}>
                                    {i.indirizzo || "&nbsp;"}
                                </p>

                                <div className={`subsidiary-card-show-map text-sm ${currentMapToShow == `map-${idx}` ? "anim-pulse anim-slow" : ""}`}>
                                    <span
                                        onClick={() => {
                                            showMap(`map-${idx}`, i.coordinate);
                                        }}>
                                        {currentMapToShow == `map-${idx}` ? t("nascondi_mappa") : t("mostra_mappa")}
                                    </span>
                                </div>

                                <div className="map-container">
                                    <div
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                        }}
                                        id={`map-${idx}`}></div>
                                </div>
                            </div>
                        </SplideSlide>
                    ))}
                </Splide>
            </div>

            {/* giorni */}
            <div id="days-splide" className="section full-screen on-mobile">
                <div className="fade"></div>
                <Splide
                    ref={daySlider}
                    options={widgetOptions.splideGiorni}
                    onMove={() => {}}
                    onDragging={() => {}}
                    onMoved={(splide, newIdx) => {
                        onGiorniSlideChange(newIdx);
                    }}
                    onClick={(splide, slide) => {                        
                        update("log_date_clicks", read("log_date_clicks") + 1);                        
                    }}
                    onReady={() => {}}>
                    {read("disponibilita").map((i, idx) => (
                        <SplideSlide key={`${i.data}-${idx}`}>
                            <div className={`white-box day-card-component text-uppercase clickable ${idx == 99 ? "show-next-days" : ""}`}>
                                <h2 className="actual-date">
                                    {getWeekDay(i.data, true)}
                                    {getWeekDay(i.data, true) && <br />}
                                    <span dangerouslySetInnerHTML={{ __html: getDayAndMonth(i.data, true) || "" }}></span>
                                </h2>

                                <h2 className="fake-date">Mostra successive</h2>
                            </div>
                        </SplideSlide>
                    ))}
                </Splide>
            </div>

            {/* ore */}
            <div className={`hour-grid-component`}>
                {isFilialiSlideBusy() && (
                    <>
                        <div className="sliders-loader loading-placeholder hours-loader"></div>
                    </>
                )}
                <div className="flex-row hours-grid__cells-container">
                    {read("orari").map((i, idx) => (
                        <div
                            key={`hour-grid-${idx}`}
                            onClick={() => {
                                if (!i.disponibile) return;

                                update("log_time_clicks", read("log_time_clicks") + 1);                            
                                update("orarioScelto", { idx, hour: i.hour, minute: i.minute });
                            }}
                            className={`white-box hour-cell flex-cell ${
                                read("orarioScelto") && i.hour == read("orarioScelto").hour && read("orarioScelto") && i.minute == read("orarioScelto").minute && i.disponibile == true
                                    ? "is-active"
                                    : ""
                            } ${!i.disponibile ? "disabled" : ""}`}>
                            <h2>{`${i.hour}:${getFullMinute(i.minute)}`}</h2>
                        </div>
                    ))}
                </div>
            </div>

            <br />
            <div className="section text-center">
                <Button id="go-to-select-state-btn" disabled={!isCfPageReady()} onClick={next} classList="btn-responsive always-style" loading={false} text={t("avanti")} />
            </div>

            <ErrorModal
                open={fetchError}
                text={fetchErrorMessage}
                onCloseModal={() => {
                    setFetchError(false);
                }}></ErrorModal>

            <EditAppointmentModal open={showModal} title={t("modifica_appuntamento")} text={t("modifica_appuntamento_esistente_unknown_nocf")} onCloseModal={closeModal} />
        </div>
    );
};
